import axios from "@/plugins/axios";

let url = (data) => "/api/console/mes/reports/${process}/${planDate}/body".interpolate(data);

export const body = {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
};

export default body;
